import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { draftClaimLineItemContext } from '~/app/features/crew/claim-line-items/claimLineItemMiddleware';
import { crewClaimContext } from '~/app/features/crew/crewClaimMiddleware';
import { makeAction, makeLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData } = makeLoader(({ context }) => {
  const { claimType } = context.get(crewClaimContext);
  const {
    quantity,
    lineItem: { currentQuantity },
  } = context.get(draftClaimLineItemContext);

  return currentQuantity === 1
    ? redirect('reason')
    : {
        currentQuantity,
        quantity,
        claimType,
      };
});

export const INPUT_KEY = 'quantity';

const makeFormSchema = (max: number) =>
  zfd.formData({
    [INPUT_KEY]: zfd.numeric(z.number().min(1).max(max)),
  });

export const { action, useActionResult } = makeAction(
  ({ formData, context }, appStore) => {
    const draftClaimLineItem = context.get(draftClaimLineItemContext);
    const result = makeFormSchema(
      draftClaimLineItem.lineItem.currentQuantity,
    ).safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Invalid data submitted. Please try again.',
      };
    }

    appStore.dispatch(
      appStore.actions.draftClaimLineItem.setQuantity(result.data.quantity),
    );

    return redirect('reason');
  },
);
